import api from "../ApiConfig";
import { Apis } from "../../config";
import { NotificationManager } from "react-notifications";
import unauthService from "../unauth";

const CreateJournal = async (data) => {
  try {
    const result = await api.post(Apis.GetAllJournalPath, data, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    NotificationManager.success(result.data.message, "Success");
    return result.data;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const GetAllJournalList = async (query) => {
  try {
    // &categoryId=${query.categoryId}
    const response = await api.get(
      `${Apis.GetAllJournalPath}?searchName=${query.search}`,
      {
        // withCredentials: true,
        headers: { "Content-Type": "application/json" },
      }
    );
    let result = JSON.parse(response.data);
    let parsedData = JSON.parse(result.body);

    if (response.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return parsedData.additionalData;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};
const DeleteJournalList = async (id) => {
  try {
    const result = await api.delete(`${Apis.GetAllJournalPath}?id=${id}`, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    NotificationManager.success(result.data.message, "Success");
    return result.data;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const UpdateJournalList = async (data, id) => {
  try {
    const result = await api.put(`${Apis.GetAllJournalPath}?id=${id}`, data, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    NotificationManager.success(result.data.message, "Success");
    return result.data;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};
const GetAllJournal = async (query) => {
  try {
    const result = await api.get(`${Apis.GetAllJournalPath}/all`, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    let parsedData = JSON.parse(result.data);
    let response = JSON.parse(parsedData.body);
    console.log(parsedData);
    //
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return response.additionalData;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};
const GetjournalByUserId = async (userId) => {
  console.log("userId", userId);
  try {
    const result = await api.get(
      `${Apis.GetAllJournalPath}/selected?userId=${userId}`,
      {
        // withCredentials: true,
        headers: { "Content-Type": "application/json" },
      }
    );
    let parsedData = JSON.parse(result.data);
    let response = JSON.parse(parsedData.body);
    console.log(parsedData);
    //
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return response.additionalData;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

export default {
  CreateJournal,
  GetAllJournalList,
  DeleteJournalList,
  UpdateJournalList,
  GetAllJournal,
  GetjournalByUserId,
};
